import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { combineLatest, map, switchMap, tap } from 'rxjs';
import { filterIsNotUndefined } from '@kaseya-utils';
import { PartnerProgramActiveFacade } from '@layout/partner-program-active/facades/partner-program-active.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { Permission } from '@core/permissions/models/permission.enum';
import { AuthorizationService } from '@core/authorization/services/authorization.service';

export const isPartnerProgramActiveGuard: CanMatchFn = () => {
  const facade = inject(PartnerProgramActiveFacade);
  const permissionsFacade = inject(PermissionsFacade);
  const authorizationService = inject(AuthorizationService);
  const router = inject(Router);
  const isMigrated = authorizationService.isMigratedUser();

  return permissionsFacade.permissionsLoaded$.pipe(
    tap(() => {
      if (!isMigrated && permissionsFacade.hasPermission(Permission.PartnerProgram)()) {
        facade.loadPartnerProgramActiveIfNotMigrated();
      } else {
        facade.setPartnerProgramInactive();
      }
    }),
    switchMap(() => combineLatest([facade.isPartnerProgramActive$, facade.loading$, facade.error$])),
    map(([hasAccess, isLoading, hasError]) => {
      const isInitializing = hasAccess === undefined && !hasError;
      if (isInitializing || isLoading) {
        return undefined;
      }

      if (!hasAccess || hasError) {
        return router.createUrlTree(['access-denied']);
      }

      return true;
    }),
    filterIsNotUndefined()
  );
};
